/* Transition End constant */
var TRANSITION_END = "webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend";

/* Generate a random password */
function generatePassword() {
  var length = Math.round(Math.random() * 8) + 8,
  charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
  retVal = "";
  for (var i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

/* Stronger parseFloat */
function asFloat(value) {
  if (value === '') {
    value = 0
  }
  if (value == undefined){
    value = 0;
  }
  return parseFloat(value.toString().replace(/\s/g,'').replace(',','.'));
}

/* Option de menu déroulant: nom, puis compagnie à côté, en petit et en pâle.
   Dans une boîte trop étroite, la compagnie passe en entier sous le nom. */
function optionWithCompany(state) {
  if (!state.element) {
    return state.text;
  }
  var company = $(state.element).data("company");
  if (!company) {
    return state.text;
  }
  return $("<span></span>").append(
    $("<span></span>").addClass("mr-2").text(state.text),
    $("<span></span>").addClass("d-inline-block small text-muted").text(company)
  );
}

/* Paramètres Select2 qui affichent la compagnie à côté du nom */
function select2WithCompany(options) {
  options = options || {};
  options.templateResult = optionWithCompany;
  options.templateSelection = optionWithCompany;
  return options;
}
